module.exports = __webpack_public_path__ + "static/media/Abu's Dine In Menu - May 2024.43932139.pdf";